<template>
  <span ref="el">{{ display }}{{ suffix }}</span>
</template>

<script>
export default {
  name: 'CountUp',
  props: {
    to: { type: Number, required: true },
    duration: { type: Number, default: 1600 },
    suffix: { type: String, default: '' },
    decimals: { type: Number, default: 0 },
    grouping: { type: Boolean, default: true },
  },
  data() {
    return { current: 0, started: false, io: null, raf: null }
  },
  computed: {
    display() {
      return this.current.toLocaleString('en-US', {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals,
        useGrouping: this.grouping,
      })
    },
  },
  mounted() {
    const reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduce) {
      this.current = this.to
      return
    }
    this.io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.started) {
          this.started = true
          this.animate()
          this.io.disconnect()
        }
      },
      { threshold: 0.4 }
    )
    this.io.observe(this.$refs.el)
  },
  beforeUnmount() {
    if (this.io) this.io.disconnect()
    if (this.raf) cancelAnimationFrame(this.raf)
  },
  methods: {
    animate() {
      const start = performance.now()
      const from = 0
      const step = (now) => {
        const p = Math.min((now - start) / this.duration, 1)
        // easeOutExpo，收尾更自然
        const eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p)
        this.current = from + (this.to - from) * eased
        if (p < 1) this.raf = requestAnimationFrame(step)
        else this.current = this.to
      }
      this.raf = requestAnimationFrame(step)
    },
  },
}
</script>
